import React, { Component } from "react";
import { Box, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, InputLabel, Select, MenuItem, FormControl } from "@mui/material";
// import TeamItem from '../../container/Employee/TeamItem/TeamItem'
import { DataGridPro } from '@mui/x-data-grid-pro';

class TeamList extends Component {
    constructor(props) {
        super(props)
        this.toggleCheckBox = this.toggleCheckBox.bind(this)
    }
    state = {
        selected: [],
        // showModal: false
        chosenDesg: '',
        open: false,
        desgModalOpen: false
    }
    handleDelConfirmModal = () => {
        this.setState({open: !this.state.open})
    }
    handleDesgModal = () => {
        this.setState({ desgModalOpen: !this.state.desgModalOpen })
    }

    toggleCheckBox(id) {
        if (!this.state.selected.includes(id)) {
            this.setState({ selected: [...this.state.selected, id] })
        } else {
            let selected = this.state.selected.filter((selId) => (selId !== id))
            this.setState({ selected })
        }
    }
    render() {
        // let empList = this.props.employeeList.map((emp)=>(<TeamItem key={emp.id} onClick={this.toggleCheckBox} selected={this.state.selected.includes(emp.id)} data={emp}/>))
        let cols = [
            {
                field: 'id',
                headerName: ' ',
                width: 70,
                hide: false,
                renderCell: (params) => {
                    // console.log('from render cell ', params.row.id)
                    return (
                        <div>
                            <i style={{ color: '#3FA7D6', margin: 10 }} onClick={() => this.toggleCheckBox(params.value)} className={this.state.selected.includes(params.value) ? "fas fa-check-square" : "far fa-square"}></i>

                        </div>
                    )
                }
            },
            {
                field: 'employee_name',
                headerName: 'NAME',
                width: 250,
                flex: 1,
                hide: false
            },
            {
                field: 'userPrincipalName',
                headerName: 'USER PRINCIPAL NAME',
                width: 350,
                flex: 1,
                hide: false
            },
            {
                field: 'emp_email',
                headerName: 'EMAIL',
                width: 300,
                flex: 1,
                hide: false
            },
            {
                field: 'emp_type',
                headerName: 'DESIGNATION',
                width: 250,
                flex: 1,
                hide: false
            }

        ]
        let selectedEmp = this.state.selected.map((emp) => {
            let employeeObj = this.props.employeeList.find((empl) => (empl.id === emp))
            return <div key={employeeObj.id}><span style={{ background: '#EBF8FF', fontSize: '1rem', fontFamily: 'Lato' }} className="badge badge-pill m-1">{employeeObj.employee_name}</span></div>
        });
        let empType = this.props.desgList.map((desg, i) => (<MenuItem key={i} value={desg}>{desg}</MenuItem>))
        return (
            <div style={{ width: '100%'}}>
                <h5>{this.props.contextName}</h5>
                {this.state.selected.length !== 0 &&
                    <div className="d-flex flex-row justify-content-start">
                        {(this.props.user.type === 'Admin' || this.props.user.type === 'Manager' || !!this.props.user.emp_is_admin) && <button onClick={(e) => { this.handleDelConfirmModal(); }} type="button" style={{ background: 'white', fontSize: '1rem', fontFamily: 'Lato' }} className="btn mx-1">
                            <i style={{ fontSize: '1rem', margin: 5 }} className="fas fa-trash"></i>REMOVE
                        </button>}
                        <Dialog open={this.state.open} onClose={this.handleDelConfirmModal}>
                            <DialogTitle>Delete Team Members</DialogTitle>
                            <DialogContent>
                                <div style={{ textAlign: 'center' }}>Are you sure you want to delete these team members?</div>
                            </DialogContent>
                            <DialogActions sx={{ justifyContent: 'center', margin: 2 }}>
                                <Button variant="outlined" onClick={() => {this.handleDelConfirmModal()}}>
                                    Back
                                </Button>
                                <Button variant="contained" onClick={()=> { 
                                    this.props.onRemove(this.state.selected); 
                                    this.setState({ selected: [] });
                                    this.handleDelConfirmModal()
                                    }
                                }
                                >
                                    Yes
                                </Button>
                            </DialogActions>
                        </Dialog>
                        {(this.props.user.type === 'Admin' || !!this.props.user.emp_is_admin) && <Button variant="text" sx={{ background: 'white', fontSize: '1rem', fontFamily: 'Lato', textTransform: 'none' }} onClick={() => this.handleDesgModal()}>
                            <i style={{ fontSize: '1rem', margin: 5 }} className="fas fa-portrait"></i>CHANGE DESIGNATION
                        </Button>}
                    </div>
                }
                {this.state.selected.length === 0 &&
                    <p className="text-muted">
                        Select one or more entries for actions. Click on an entry to edit
                    </p>}
                <Box sx={{ width: '100%', minWidth: 0, height: 'calc(100vh - 175px)' }}>
                <DataGridPro
                    rows={this.props.employeeList}
                    columns={cols}
                    onRowSelected={(params) => this.toggleCheckBox(params.data.id)}
                    showToolbar
                    density="compact"
                    onCellClick={(params) => this.toggleCheckBox(params.id)} 
                />
                </Box>
                <Dialog open={this.state.desgModalOpen} onClose={() => this.handleDesgModal()} fullWidth maxWidth="sm">
                    <DialogTitle>Employee Update</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} sx={{ margin: 1 }}>
                            {selectedEmp}
                        </Grid>
                        <FormControl fullWidth sx={{ marginTop: 2 }}>
                            <InputLabel>CHOOSE DESIGNATION</InputLabel>
                            <Select
                                value={this.state.chosenDesg}
                                onChange={(e) => this.setState({ chosenDesg: e.target.value })}
                                label="CHOOSE DESIGNATION"
                                required
                            >
                                <MenuItem value="">Select Type</MenuItem>
                                {empType}
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={(e) => { this.props.onDesgChange(this.state.selected, this.state.chosenDesg); this.setState({ selected: [], chosenDesg: '' }); this.handleDesgModal(); }}>Save changes</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default TeamList;